export const getCurrentUTCDayTimestamp = () => {
  const today = new Date();
  today.setUTCHours(0, 0, 0, 0);
  return today.getTime();
};


export const generateDailyPassword = (id) => {
  const utcTimestamp = getCurrentUTCDayTimestamp();
  const seed = `${id}${utcTimestamp}`;
  const hash = [...seed].reduce(
    (acc, char) => (acc * 31 + char.charCodeAt(0)) % 1_000_000,
    0,
  );

  return Math.abs(hash).toString().slice(-6).padStart(6, '0');
};

export const getPasswordExpirationTime = () => {
  const nextMidnightUTC = getCurrentUTCDayTimestamp() + 24 * 60 * 60 * 1000;
  const localTime = new Date(nextMidnightUTC);
  return localTime.toLocaleString();
};
